import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import at from 'lodash/at'
import get from 'lodash/get'
import Select from 'react-select'

import { loadInspectorsForLocation } from '../../actions/inspectors'

const selector = createSelector(
  [
    (state) => state.inspectors,
    (state, locationId) => get(state, `pagination.inspectorsByLocation.${locationId}`, {}).ids
  ],
  (inspectors, inspectorsForLocation) => at(inspectors, inspectorsForLocation || []).map(ins => ({value: ins.id, label: ins.name}))
)

function mapStateToProps (state, ownProps) {
  const locationId = ownProps.locationId

  const options = selector(state, locationId)

  return {
    options
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const locationId = ownProps.locationId

  return {
    onMenuScrollToBottom () {
      dispatch(loadInspectorsForLocation(locationId, true))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Select)



// WEBPACK FOOTER //
// ./src/containers/inspections/select-inspector-container.js